<template>
  <a-form :form="form">
    <a-form-item
      label="卡片上传："
      :label-col="{ span: 7 }"
      :wrapper-col="{ span: 12 }"
      :validate-status="avatarStatus"
      :help="avatarHelp"
      required
    >
      <upload-img class-name="card-avatar-uploader" v-model="formData.avatar" />
    </a-form-item>
    <a-form-item :wrapper-col="{ span: 24 }">
      <div class="title">卡片信息</div>
    </a-form-item>
    <a-form-item label="所属APP：" :label-col="{ span: 7 }" :wrapper-col="{ span: 13 }">
      <div class="value">{{ appName }}</div>
    </a-form-item>
    <a-form-item label="卡片名称：" :label-col="{ span: 7 }" :wrapper-col="{ span: 12 }" required>
      <a-input
        placeholder="请输入卡片名称"
        v-decorator="['displayName', { rules: [{ required: true, message: '请输入卡片名称' }] }]"
      />
    </a-form-item>
    <a-form-item
      label="客户端版本："
      :label-col="{ span: 7 }"
      :wrapper-col="{ span: 12 }"
      :validate-status="editionStatus"
      :help="editionHelp"
      required
    >
      <CardSelect
        :list="clientList"
        placeholder="请选择客户端版本"
        v-model="formData.edition"
        extra-style="width: 100%"
      />
    </a-form-item>
    <a-form-item label="卡片简介：" :label-col="{ span: 7 }" :wrapper-col="{ span: 12 }" required>
      <a-textarea
        v-decorator="['description', { rules: [{ required: true, message: '请输入卡片简介' }] }]"
        placeholder="请输入卡片简介"
        :rows="4"
        :max-length="500"
      />
    </a-form-item>
    <a-form-item label="组件Key：" :label-col="{ span: 7 }" :wrapper-col="{ span: 12 }" required>
      <a-input
        v-decorator="['componentKey', { rules: [{ required: true, message: '请输入组件Key' }] }]"
        placeholder="请输入组件Key"
      />
    </a-form-item>
  </a-form>
</template>

<script>
import UploadImg from '../../../appearance/components/UploadImg.vue'
import CardSelect from '../../../../../components/AppSelect/index.vue'

export default {
  name: 'CardForm',
  components: {
    UploadImg,
    CardSelect
  },
  props: {
    visible: {
      // 是否展示
      type: Boolean,
      default: false
    },
    appName: {
      type: String,
      required: true
    },
    cardInfo: {
      type: Object
    },
    clientList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      formData: {
        avatar: '',
        displayName: '',
        description: '',
        componentKey: '',
        edition: ''
      },
      avatarStatus: '',
      avatarHelp: '',
      displayNameStatus: '',
      displayNameHelp: '',
      descriptionStatus: '',
      descriptionHelp: '',
      componentKeyStatus: '',
      componentKeyHelp: '',
      editionStatus: '',
      editionHelp: '',
      validate: {
        avatar: { status: '', help: '' },
        displayName: { status: '', help: '' },
        description: { status: '', help: '' },
        componentKey: { status: '', help: '' },
        edition: { status: '', help: '' }
      }
    }
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.initial()
          this.initialUserForm()
        }
      },
      immediate: true
    },
    cardInfo: {
      handler(val) {
        if (val) {
          this.initial()
          this.initialUserForm()
        }
      },
      immediate: true,
      deep: true
    },
    'formData.avatar': {
      handler(val) {
        if (val) {
          this.avatarStatus = ''
          this.avatarHelp = ''
        }
      },
      deep: true
    }
  },
  methods: {
    initial() {
      this.formData = {
        avatar: '',
        displayName: '',
        description: '',
        componentKey: '',
        edition: ''
      }
      // 校验状态清空
      this.validate = {}
      // 默认选择第一项
      if (this.clientList.length) {
        this.formData.edition = this.clientList[0].value
      }

      // if (this.cardInfo) {
      //   Object.assign({}, this.cardInfo, { edition: String(this.cardInfo.edition) })
      // }
    },
    // 表单数据绑定
    initialUserForm() {
      // 默认选择第一项
      if (!this.cardInfo || JSON.stringify(this.cardInfo) === '{}') {
        this.form = this.$form.createForm(this)
        return
      }
      const { avatar, displayName, description, componentKey, edition } = this.cardInfo
      this.formData.avatar = avatar
      this.formData.edition = String(edition)
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          let fields = {
            displayName: this.$form.createFormField({
              value: displayName
            }),
            componentKey: this.$form.createFormField({
              value: componentKey
            }),
            description: this.$form.createFormField({
              value: description
            })
          }
          return fields
        }
      })
    },
    handleValidate() {
      let flag = true
      return new Promise((resolve) => {
        this.form.validateFieldsAndScroll((err, values) => {
          Object.assign(this.formData, values)
          if (err) {
            flag = false
          }
          if (!this.formData.avatar) {
            this.avatarStatus = 'error'
            this.avatarHelp = 'App卡片图片不能为空'
            flag = false
          }
          if (!this.formData.edition) {
            this.editionStatus = 'error'
            this.editionHelp = '客户端版本不能为空'
            flag = false
          }
          resolve(flag)
        })
      })
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .ant-form-item {
  margin-bottom: 16px;

  &:first-child,
  &:last-child {
    margin-bottom: 0;
  }
}

.title {
  height: 22px;
  line-height: 22px;
  border-left: 4px solid #457cbe;
  color: #457cbe;
  padding: 0 12px;
}

.value {
  color: rgba(0, 0, 0, 0.65);
}

/deep/ .card-avatar-uploader {
  width: 330px;
  height: 192px;

  .img-panel {
    height: 160px;
    width: 330px;
  }
}
</style>
